import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { WorkService } from '../services';

@Component({
  selector: 'app-test-mode',
  templateUrl: './test-mode.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestModeComponent implements OnInit {
  constructor(private route: ActivatedRoute, private workSvc: WorkService) {}
  ngOnInit(): void {
    this.route.queryParams
      .pipe(
        map((p) => ({
          campaignId: +p['campaignId'],
          version: +p['version'],
          question: +p['question'],
          hash: p['hash'] as string,
          secret: 'hhhYTSkkidEDd',
        })),
        switchMap((p) =>
          from(
            crypto.subtle.digest(
              'SHA-256',
              new TextEncoder().encode(
                `${p.campaignId},${p.version},${p.question}${p.secret}`
              )
            )
          ).pipe(
            map((buffer) => ({
              ...p,
              checkHash: Array.from(new Uint8Array(buffer))
                .map((b) => b.toString(16).padStart(2, '0'))
                .join(''),
            }))
          )
        )
      )
      .subscribe((p) => {
        if (p.checkHash === p.hash) {
          this.workSvc.popTestScript(p.campaignId, p.version, p.question);
        }
      });
  }
}
